<template>
  <div>
    <input-toggle 
        :value="value"
        :disable="disable"
        @change="toggleChange"
    />
  </div>
</template>

<script>
import InputToggle from "@/InputToggle/src/InputToggle.vue";
export default {
  components: {
    InputToggle,
  },
  props: {
    itemKey: String,
    value: String,
    disable: String,
    uri: String,
  },
  methods: {
    toggleChange(target) {
      fetch(this.uri, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: this.itemKey,
          state: target.checked ? "1" : "0",
          _token: document
            .querySelector('meta[name="csrf-token"]')
            .getAttribute("content"),
        }),
      })
      .then(response => response.json())
      .then(data => {
        target.checked = data.state == "1" ? true : false;
      })
      .catch( error => {
          target.checked =  this.value == "1" ? true : false;
          window.console.log("Error at ToggleAjax: "+error);
      })
    },
  },
};
</script>
